import Vue from 'vue'
import index from './index.vue'
import router from '../router'

/* eslint-disable no-new */
new Vue({
  el: '#index',
  router,
  render: h => h(index)
})



// WEBPACK FOOTER //
// ./src/module/index.js